import { makeStyles } from '@material-ui/styles';
import { Values } from '../../../../values/Values';


const useStyles = makeStyles(theme => ({
  root: {
    margin: theme.spacing(3),
    borderRadius: 15
  },
  title: {
    textAlign: 'center',
  },
  instrucoes: {
    textAlign: 'center',
  },
  gridBotaoContinuar: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  botaoContinuar: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.white,
  },
}));

export {useStyles}

